// Core
import React, { useState } from 'react'

// Custom layout
import MainLayout from '../../../Layouts/Main'

//styles
import "./style.scss"

//router
import { NavLink, useLocation, useNavigate, Outlet, Link } from "react-router-dom";


const ChooseKG = () => {

  const requestNavLinks = [{
    to: "becomeDistributor",
    label: "Become Distributor",
    id: "1",
  },
  {
    to: "newsletter",
    label: "Newsletter",
    id: "2",
  },
  {
    to : "contact-us",
    label : "Contact us",
    id : "3",
  },
  {
    to : "quote-request",
    label : "Quote Request",
    id : "4",
  },
]

  return (
    <MainLayout pageName={"Choose KG"}>
    <div className='chooseContainer1'>
      <div className="chooseNavBar">
        {requestNavLinks.map((option)=>(
          <div key={option.id} className="chooseOptionContainer">
            <NavLink
              key={option.id}
              to={option.to}
              style={{textDecoration:"none"}}
              className={({ isActive }) =>
                isActive ? "active-chooseOptionContainerNav" : "chooseOptionContainerNav"
              }
            >
              {option.label}
            </NavLink>
          </div>
        ))}
      </div>
      <Outlet/>
    </div>
    </MainLayout>
  )
}

export default ChooseKG
